import React, { Component } from "react";
import { Spin, Typography, message } from "antd";
import { connect } from "react-redux";
import axios from "axios";
import SwitchItem from "../../../../Components/SwitchItem";

const { Title, Paragraph } = Typography;

class DashboardConfiguracion extends Component {
  state = { loading: true, guardando: false, vistaTabla: false };

  componentDidMount() {
    this.consultarConfiguracion();
  }

  consultarConfiguracion = () => {
    axios
      .post(
        "configuracionTiendaOnline/obtenerConfiguracionDashboard",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            vistaTabla: res.data.data?.vistaVentasEcommerce === "tabla",
          });
        }
      })
      .finally(() => this.setState({ loading: false }));
  };

  onCambiarVista = (checked) => {
    this.setState({ vistaTabla: checked, guardando: true });
    axios
      .post(
        "configuracionTiendaOnline/actualizarConfiguracionDashboard",
        {
          empresaId: this.props.empresaId,
          vistaVentasEcommerce: checked ? "tabla" : "kanban",
        },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Preferencia de vista guardada");
        } else {
          message.error("No se pudo guardar la preferencia");
          this.setState({ vistaTabla: !checked });
        }
      })
      .catch(() => {
        message.error("Error al comunicar con el servidor");
        this.setState({ vistaTabla: !checked });
      })
      .finally(() => this.setState({ guardando: false }));
  };

  render() {
    const { loading, guardando, vistaTabla } = this.state;
    return (
      <Spin spinning={loading}>
        <div style={{ padding: "10px 4px", maxWidth: 640 }}>
          <Title level={5}>Vista de Ventas eCommerce</Title>
          <Paragraph type="secondary">
            Elige cómo se muestran los pedidos de Ventas eCommerce: como un
            tablero visual (arrastrar y soltar tarjetas por columna) o como
            una tabla paginada con filtros y botones por fila. La tabla es
            la opción recomendada cuando manejas un volumen alto de pedidos.
          </Paragraph>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <SwitchItem
              checked={vistaTabla}
              loading={guardando}
              onChange={this.onCambiarVista}
            />
            <span>{vistaTabla ? "Vista de tabla" : "Vista de tablero (Kanban)"}</span>
          </div>
        </div>
      </Spin>
    );
  }
}

const mapStateToProps = (state) => ({
  empresaId: state.empresa.id,
  headersToken: state.user.headersToken,
});

export default connect(mapStateToProps)(DashboardConfiguracion);
